import Sentry from 'Integrations/Sentry';
import SentryScopedError from './SentryScopedError';

export default class PanicError extends SentryScopedError {
  constructor(errorCode, message, details = {}) {
    super({
      errorCode,
      message,
      details,
    });

    this.name = 'PanicError';
    this.errorCode = errorCode; // Machine comparable value
    this.message = message; // Human readable reason (IE. Message)
    this.details = details; // Any other details

    Sentry.createSentryErrorLog(this);
  }
}
